import { takeEvery, takeLatest } from "redux-saga/effects";
import {
  getMyPurchasesAction,
  getMyCoursesAction,
  getUpcomingCoursesAction,
  getDiscountsAction,
  createDiscountAction,
  deleteDiscountAction,
} from "./slices";
import {
  getMyPurchasesWorker,
  getMyCoursesWorker,
  getUpcomingCoursesWorker,
  getDiscountsWorker,
  createDiscountWorker,
  deleteDiscountWorker,
} from "./workers";

const intructorCourseWatcher = [
  takeEvery(getMyCoursesAction, getMyCoursesWorker),
  takeEvery(getMyPurchasesAction, getMyPurchasesWorker),
  takeEvery(getUpcomingCoursesAction, getUpcomingCoursesWorker),
  takeEvery(getDiscountsAction, getDiscountsWorker),
  takeEvery(createDiscountAction, createDiscountWorker),
  takeEvery(deleteDiscountAction, deleteDiscountWorker),
];

export default intructorCourseWatcher;
